import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactNode } from 'react';

import { useUserStore } from '@/configs/store';
import { useGlobalUserFilterModel } from '@/features/globalUserFilter';

type Props = PropsWithChildren<{
  loadingFallback?: ReactNode;
  fallback?: ReactNode;
}>;

/**
 * Показывает children только если выбранный пользователь — это текущий авторизованный пользователь
 * Используется для скрытия UI при просмотре чужих данных
 */
const CurrentUserOnlyGuard = ({ children, loadingFallback, fallback }: Props) => {
  const { isLoading: isUserLoading, user: currentUser } = useUserStore();
  const { loadingStage, isViewingSelf } = useGlobalUserFilterModel();

  if (isUserLoading || loadingStage.isLoading) {
    return loadingFallback || null;
  }

  if (!currentUser) {
    return fallback || null;
  }

  if (!isViewingSelf) {
    return fallback || null;
  }

  return children;
};

export default observer(CurrentUserOnlyGuard);
